<script setup lang="ts" generic="Value extends boolean">
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { FormFieldBooleanComponent } from '@shared/common/form/application/component/boolean/form-field-boolean-component.types';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { BooleanFormField } from '@shared/common/form/domain/form/field/boolean.form-field';

const model = defineModel<BooleanFormField<Value>>({ required: true });
const component = container.get<FormFieldBooleanComponent>(FormDependencyTypes.FormFieldBooleanComponent);
</script>

<template>
  <div>
    <component :is="component" v-model="model.value" v-bind="model" />
    <form-field-messages :help-text="model.hint" :errors="model.errorMessages" />
  </div>
</template>
